import { Card, Col, Row } from "antd";
import React from "react";
import { translate } from "react-i18next";
import { compose } from "redux";
import { GUTTER_SM, MARGIN_MD } from "../../../styles/constants";
import { cardStyle, EL_MAPPING_ROW_HEIGHT } from "./constants";
import ELComponentMapper from "./ELComponentMapper";
import ELCsvHeaderList from "./ELCsvHeaderList";
import ELCubeComponentList from "./ELCubeComponentList";

const ELMapper = ({
  t,
  csvHeader,
  components,
  cube,
  selectedMapping,
}) => {
  return (
    <Row gutter={GUTTER_SM}>
      <Col span={7}>
        <div className="file-mapping__wizard__csv-header">
          <Card
            title={t('components.easyLoading.steps.mapping.cards.csvHeader.title')}{...cardStyle}                        
          >
            <Row style={{marginBottom: MARGIN_MD, height: EL_MAPPING_ROW_HEIGHT}}>
              <ELCsvHeaderList
                csvHeader={csvHeader}
                selectedMapping={selectedMapping}
              />
            </Row>
          </Card>
        </div>
      </Col>
      <Col span={10}>
        <div className="file-mapping__wizard__component-mapper">
          <Card {...cardStyle}>
            <Row style={{marginBottom: MARGIN_MD, height: EL_MAPPING_ROW_HEIGHT}}>
            {selectedMapping && 
              <ELComponentMapper
                components={components}
                csvHeader={csvHeader}
                cube={cube}
                selectedMapping={selectedMapping}
              />
            }
            </Row>
          </Card>
        </div>
      </Col>
      <Col span={7}>
        <div className="file-mapping__wizard__cube-components">
          <Card title={t('components.easyLoading.steps.mapping.cards.cubeComponents.title')}{...cardStyle}>
            <Row style={{marginBottom: MARGIN_MD, height: EL_MAPPING_ROW_HEIGHT}}>
              <ELCubeComponentList
                cube={cube}
                selectedMapping={selectedMapping}
            />
            </Row>
          </Card>
        </div>
      </Col>
    </Row>
  );
};

export default compose(
  translate()
)(ELMapper);



// WEBPACK FOOTER //
// ./src/components/easy-loading/mapping-step/ELMapper.jsx